"use client";

import { Filterkopf, Luecke, Schiene, Suchfeld, useAnsicht, Zaehlknopf } from "@/components/liste";
import { PHASEN } from "@/lib/spenden/ansicht";

/** Kopf der Aufrufliste: Suche und „Aktuell · Beendet · Alle“. */
export function AufrufeFilterkopf({ q, phase, zaehler }: { q: string; phase: string; zaehler: Record<string, number> }) {
  const { setzen, isPending } = useAnsicht();
  return (
    <Filterkopf
      isPending={isPending}
      zuklappbar={false}
      oben={
        <>
          <Suchfeld wert={q} platzhalter="Titel, Zweck …" beschriftung="Aufrufe durchsuchen" />
          <Luecke />
          <Schiene>
            {PHASEN.map((p) => (
              <Zaehlknopf
                key={p.schluessel || "aktuell"}
                label={p.label}
                anzahl={zaehler[p.schluessel] ?? 0}
                aktiv={phase === p.schluessel}
                titel={p.schluessel === "" ? "Laufende und geplante Aufrufe" : undefined}
                onClick={() => setzen({ phase: p.schluessel || null })}
              />
            ))}
          </Schiene>
        </>
      }
    />
  );
}
